import React, { useState } from "react"
import { SocialFacebook, SocialLink, SocialLinkedIn } from "@icons"
import { FacebookShareButton, LinkedinShareButton } from "react-share"

export const ArticleSocial = () => {
  const [URLCopied, setURLCopied] = useState(false)

  const copyURL = () => {
    setURLCopied(true)
    navigator.clipboard.writeText(window.location.href)
    setTimeout(() => {
      setURLCopied(false)
    }, 2000)
  }

  return (
    <div className="article-content__social-items">
      <button onClick={copyURL}>
        <SocialLink />
        {URLCopied && <span>Link másolva</span>}
      </button>
      <FacebookShareButton
        url={
          "https://main--envimap.netlify.app/article/szeizmikus-kutatasi-terulet-terkepezesehez-nagy-pontossagu-terepmodell-eloallitasa"
        }
        quote='Envimap'
      >
        <SocialFacebook />
      </FacebookShareButton>
      <LinkedinShareButton
        url={
          "https://main--envimap.netlify.app/article/szeizmikus-kutatasi-terulet-terkepezesehez-nagy-pontossagu-terepmodell-eloallitasa"
        }
        title='Envimap'
        summary="Envimap summary"
        source="Envimap landing page"
      >
        <SocialLinkedIn />
      </LinkedinShareButton>
    </div>
  )
}
